//import { GridItem, GridWrapper } from "@sainsburys-tech/luna-grid";
import { FC } from "react";
import { Pie } from "react-chartjs-2";
import styled from "styled-components";
import { StuntTypeProp } from "../../../CustomTypes/Filters";
//import { useDashboardData } from "../../../Hooks/useDashboard";
import { useHookForApi } from "../../../Hooks/useHookForApi";
//import LoadingIndicator from "../../LoadingIndicator";
import "./dashboard.scss";
import { errorToast } from "../../../Utils/toastMessage";
import CustomToast from "../../CustomToast/CustomToast";

const ChartWarapper = styled.div`
  max-width: auto;
  margin: 0 auto;
`;

const StoreOrder: FC<StuntTypeProp> = (stuntType) => {
  const onSuccess = (data: any) => {
    if (data.isAxiosError && data.name === 'Error' && data.message === "Network Error") {
      errorToast(JSON.stringify(`Unable to connect with Journey service and possible reason is: (${data})`));
    }
  };
  const onError = (error: any) => {
    //console.clear()
  };

  //purchaseorders/dashboard
  const {
    isLoading: isDataLoading,
    data:response,
    //isFetching,
  //} = useDashboardData(onSuccess, onError, `storeorders/dashboard${stuntType.stuntType}`);
  } = useHookForApi(onSuccess, onError, 0,0 , `storeorders/dashboard${stuntType.stuntType}`);

  // const labels = ["Picked", "Shipped", "Ordered"];
  const labels = ["Ordered", "Shipped", "Picked"];
  // const dataForCalulation = [data?.picked, data?.shipped, data?.ordered];
  const dataForCalulation = [response?.data?.ordered, response?.data?.shipped, response?.data?.picked];
  const customLabels = labels.map((label, index) => `${response?.data?.totalCount}`);

  const dashboardData = {
    labels: customLabels,
    datasets: [
      {
        label: "# of Votes",
        data: dataForCalulation,
        backgroundColor: [
          "rgba(63, 169, 245, 1)",
          "rgba(191, 92, 129, 1)",
          "rgba(39, 69, 104, 1)",
          "rgba(248, 181, 21, 1)",
        ],
        borderColor: [
          "rgba(63, 169, 245, 1)",
          "rgba(191, 92, 129, 1)",
          "rgba(39, 69, 104, 1)",
          "rgba(248, 181, 21, 1)",
        ],
        borderWidth: 1,
      },
    ],
  };
  const options = {
    maintainAspectRatio: false,
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: (value: any, ctx: any) => {
          let sum = 0;
          const dataArr = ctx.chart.data.datasets[0].data;
          sum = dataArr.reduce((prev: any, cur: any) => prev + cur);
          const percentage = ((value * 100) / sum).toFixed(2) + "%";
          if (percentage === "NaN%" || percentage === "0.00%") {
            return "";
          }
          return percentage;
        },
      },
    },
  };

  return (
    <>
      <div className="ln-u-soft colour">
        {/* <GridWrapper equalHeight>
          <GridItem size="1/2"> */}
        <div className="property">Number of Store Order
          <h2 className="shippedTomorrowValue">{response?.data?.totalCount}</h2>
        </div>
        {/* </GridItem>
        </GridWrapper> */}

        {/* <GridWrapper equalHeight>
          <GridItem size="1/2"> */}
        {/* <div style={{height:'150px' ,width: '250px', width: '100%', marginTop: '60px' }}> */}
        <div style={{ display: 'flex', position: 'relative' }}>
          <div className="chartStoreOrderPosition" style={{ height: '150px', }}>
            <ChartWarapper>
              <Pie data={dashboardData} options={options} width={600} height={250} />
            </ChartWarapper>
          </div>
          {/* </GridItem> */}
          {/* <GridItem size="1/2"> */}
          <div style={{ position: 'relative' }}>
            <div className="storeOrderPosition" style={{ float: 'right', width: '110px' }}>
              <div className="parent">
                Ordered ({response?.data?.ordered}) &nbsp;
                <div className="child storeOrdered"></div>
              </div>
              <div className="parent">
                Shipped ({response?.data?.shipped}) &nbsp;
                <div className="child storeShipped"></div>
              </div>
              <div className="parent">
                Picked ({response?.data?.picked}) &nbsp;
                <div className="child storePicked"></div>
              </div>
            </div>
            {/* <div className="parent">
                Shipped Tomorrow ({data?.shippedTomorrow}) &nbsp;
                <div className="child storeSkuQtyIssues"></div>
              </div> */}
          </div>
          {/* </GridItem>
        </GridWrapper> */}
        </div>
      </div>
      <CustomToast />
    </>
  );
};

export default StoreOrder;